module.exports = __webpack_public_path__ + "img/1440.cb3a9671.jpg";